var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"text-sm font-bold uppercase border rounded lg:hover:opacity-75",class:{ 'pointer-events-none opacity-50': _vm.$attrs.disabled },style:(_vm.style),attrs:{"type":_vm.type,"aria-disabled":_vm.$attrs.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }